module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('link', {
    attrs: {
      "href": "https://unpkg.com/uppy@0.27.2/dist/uppy.min.css",
      "rel": "stylesheet"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Add File")]), _vm._v(" "), _c('div', {
    staticClass: "tabs is-right"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': !_vm.linkMode
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.linkMode = !_vm.linkMode
      }
    }
  }, [_vm._v("File")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.linkMode
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.linkMode = !_vm.linkMode
      }
    }
  }, [_vm._v("Live Link")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [(!_vm.linkMode) ? _c('section', {}, [_c('p', {
    staticClass: "field flex-align-center"
  }, [_c('input', {
    staticClass: "button is-primary",
    attrs: {
      "id": "add-file",
      "value": "Upload File",
      "type": "button"
    }
  }), _vm._v(" "), (_vm.fileUploaded) ? _c('span', {
    staticClass: "is-success"
  }, [_vm._v("File Uploaded!")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "title is-5 input file-title-input",
    attrs: {
      "placeholder": "file title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.linkMode) ? _c('section', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "title is-5 input file-title-input",
    attrs: {
      "placeholder": "link url (for things like google docs or google drive files)"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "title is-5 input file-title-input",
    attrs: {
      "placeholder": "title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [(!_vm.linkMode) ? _c('button', {
    staticClass: "button is-info",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "disabled": !_vm.fileUploaded
    },
    on: {
      "click": function($event) {
        _vm.addFile()
      }
    }
  }, [_vm._v("\n          Add\n      ")]) : _vm._e(), _vm._v(" "), (_vm.linkMode) ? _c('button', {
    staticClass: "button is-info",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "disabled": _vm.url.length < 4
    },
    on: {
      "click": function($event) {
        _vm.addLink()
      }
    }
  }, [_vm._v("\n          Add\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.errorAddingFile) ? _c('span', {
    staticClass: "is-danger"
  }, [_vm._v("Error adding file")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0dce4632"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddFileModal.vue
// module id = 980
// module chunks = 0